import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {Box, Dialog, DialogContent, DialogTitle, Divider, Stack} from '@mui/material';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import type {MaterialRequirement} from '@/types/MaterialRequirement';

export type ResourcesModalState = {
    open : boolean;
    title ?: string;
    materialRequirements ?: MaterialRequirement[];
    onClose ?: () => void;
};

type Props = {
    modalState: ResourcesModalState;
    setModalState : (modalState: ResourcesModalState) => void;
};

const DialogResources = ({modalState, setModalState} : Props) : React.ReactElement => {
    const handleClose = () => {
        setModalState({
            ...modalState,
            open: false
        });
    };

    return (
        <Dialog maxWidth='sm' fullWidth={true} open={modalState.open} onClose={handleClose}>
            <DialogTitle>
                <Stack
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant='h6' fontWeight={800}>{modalState.title}</Typography>
                    <IconButton onClick={handleClose}>
                        <HighlightOffIcon/>
                    </IconButton>
                </Stack>
            </DialogTitle>
            <DialogContent sx={{minHeight: '200px'}}>
                <Typography variant="body1" fontWeight={800}>Resources</Typography>
                {modalState.materialRequirements?.map((materialRequirement) => {
                    return <Box key={`requirement-${materialRequirement.id}`} sx={{my: 2}}>
                        <Box><Typography sx={{display: 'inline', fontWeight: 800}}>Type:</Typography> {materialRequirement.type}</Box>
                        <Box><Typography sx={{display: 'inline', fontWeight: 800}}>SubType:</Typography> {materialRequirement.subType}</Box>
                        <Box><Typography sx={{display: 'inline', fontWeight: 800}}>Manufacturer:</Typography> {materialRequirement.manufacturer}</Box>
                        <Box><Typography sx={{display: 'inline', fontWeight: 800}}>Description:</Typography> {materialRequirement.description}</Box>
                        <Divider sx={{height: '3px'}}/>
                    </Box>
                })}
            </DialogContent>
        </Dialog>
    );
};

export default DialogResources;
